import { restrictions as config } from '@config';

const template = {
  color: require('./template-colors.hbs'),
  colors_library: require('./colors-library.hbs'),
  image: require('./images.hbs'),
  video: require('./videos.hbs'),
  background: require('./backgrounds.hbs')
};

module.exports = _.extend(Backbone.View.extend({
  events: {
    'click .thumbnail': 'applyElementEvent',
    'click .remove': 'removeElementEvent',
    'click .restrictions-add-color': 'calculateColorPickerPosition'
  },

  applyElementEvent: function (event) {
    this.trigger('apply', $(event.currentTarget).closest('.thumbnail').data('value'));
  },

  removeElementEvent: function (event) {
    const value = $(event.currentTarget).closest('.thumbnail').data('value');
    this.data = _(this.data).without(value);

    this.render();
    this.trigger('change', this.getData(), 'removed');
    event.stopPropagation();
  },

  addElement: function (value) {
    if (!value || _.contains(this.data, value)) {
      return;
    }

    this.data.push(value);

    this.render();
    this.trigger('change', this.getData(), 'added');
  },

  removeAllElement: function () {
    this.data.splice(0, this.data.length);
    this.render();
    // this.trigger('change', this.getData());
  },

  calculateColorPickerPosition: function () {
    const addMoreButton = this.el.querySelector('.restrictions-add-color');
    const rect = addMoreButton.getBoundingClientRect();
    const colorPicker = document.querySelector('.addmore-color-picker');
    colorPicker.style.top = `${rect.top}px`;
    colorPicker.style.left = `${rect.left - rect.height}px`;
    colorPicker.style.transform = `scale(0.6) translate(${-rect.height - config.colorPickerMargin}px, ${-rect.height}px)`;
  },

  initialize: function (options) {
    _.bindAll(this, 'render', 'addElement', 'getData');

    this.uuid = options.uuid;
    this.type = options.type;
    this.data = options.colorLibraryPalettes || [];

    this.debouncedRender = _.debounce(this.render, 500);
    this.render();
  },

  filterInvalidData: function (data) {
    return data;
  },

  render: function () {
    const currentHeight = this.el?.getBoundingClientRect().height;

    this.data = this.filterInvalidData(this.data);
    this.$el.html(template[this.type]({
      uuid: this.uuid,
      data: this.data,
      no_data: this.data.length < 1,
      show_hint: this.data.length === 1
    }));

    const updatedHeight = this.el?.getBoundingClientRect().height;

    currentHeight !== updatedHeight && this.updateContainerHeight(updatedHeight, currentHeight);
    this.type === 'color' && this.initColorPicker();
  },

  initColorPicker: function () {
    this.$el.find('.addmore').colorpicker({
      defaultColor: '#FFF',
      onSubmit: this.addElement,
      skipClearSelection: true
    });
  },

  getLibraryPaletteColors: function (paletteId) {
    const palette = _.findWhere(this.data, { id: paletteId || 0 });
    if (!palette) return;

    const $thumbnailWrapper = this.$el.find('.thumbnails-wrapper');
    $thumbnailWrapper.empty();

    _.each(palette.colors, function (obj) {
      const color = obj.data.color_code;

      $thumbnailWrapper.append('<div class="thumbnail color" style="background-color:' + color + '"></div>');
    });
  },

  setLibraryPaletteRestriction: function (selected) {
    const $select = this.$el.find('select');
    selected && selected.palette && $select.val(selected.palette);
    const paletteId = parseInt($select.val());

    this.getLibraryPaletteColors(paletteId);
    this.$el.find('input').val(paletteId);

    this.trigger('change', this.getData());
  },

  getData: function () {
    return _(this.data).clone();
  },

  updateContainerHeight: function (updatedHeight, currentHeight) {
    const container = this.el.closest('dt.element-specific-restrictions');
    const height = parseInt(container.style.height, 10);

    container.style.height = `${height - currentHeight + updatedHeight}px`;
  }
}), Backbone.Events);
